import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Menu = () => {
    const [accessLevel, setAccessLevel] = useState('');

    useEffect(() => {
        const category = localStorage.getItem("async_category");
        const role = localStorage.getItem("async_role");

        console.log("Category:", category);
        console.log("Role:", role);

        if (role === "Admin") {
            setAccessLevel(category); 
        }
    }, []);

    const isCardEnabled = (cardId) => {
        if (accessLevel === "ecosystem_admin") return true; 
        if (accessLevel === "ecosystem_guest" && cardId === 'posGas') return true; 
        if (accessLevel === "company_admin" && cardId === 'ViewStore') return true; 
        if (accessLevel === "company_admin" && (cardId === 'posGas')) return true; 
        return false; 
    };

    const handleCardClick = (cardId, event) => {
        event.preventDefault(); 
        if (!isCardEnabled(cardId)) {
            toast.error(`Access to ${cardId.replace(/([A-Z])/g, ' $1')} is disabled.`, {
                position: "top-center", 
                hideProgressBar: true, 
                closeOnClick: true, 
                pauseOnHover: true,
                draggable: true, 
                progress: undefined,
            });
        } else {
            window.location.href = `/${cardId}`; 
        }
    };

    return (
        <div className="bg-light min-vh-100 py-5">
            <ToastContainer />
            <div className="container">
                <div className="text-center mb-5">
                    <h1 className="display-4 text-primary mb-2">REMS Business Suite</h1>
                    <h3 className="text-secondary">Main Menu</h3>
                </div>

                <div className="row g-4">
                    {/* First Row */}
                    <div className="col-lg-3 col-md-6">
                        <a href="/funnel" onClick={(e) => handleCardClick('funnel', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">Ticketing</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <a href="/PosSplash" onClick={(e) => handleCardClick('PosSplash', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">POS</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <a href="/posgas" onClick={(e) => handleCardClick('posGas', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">POS Gas</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <a href="/accountmap" onClick={(e) => handleCardClick('accountmap', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">Finance</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    {/* Second Row */}
                    <div className="col-lg-3 col-md-6">
                        <a href="/PayrollEmployeeDetails" onClick={(e) => handleCardClick('PayrollEmployeeDetails', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">Payroll</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <a href="/Dashboard" onClick={(e) => handleCardClick('Dashboard', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">Pension</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <a href="/ClientLogin" onClick={(e) => handleCardClick('ClientLogin', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">Pension Client Self Service</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <a href="/XGOLifeDashboard" onClick={(e) => handleCardClick('XGOLifeDashboard', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">X Go Life</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <a href="/XGOMarketPlace" onClick={(e) => handleCardClick('XGOMarketPlace', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">XGO Market Place</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <a href="/AdminOverview" onClick={(e) => handleCardClick('AdminOverview', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">Administration Dashboard</h4>
                                </div>
                            </div>
                        </a>
                    </div>

                    {/* New Softworks Admin Card */}
                    <div className="col-lg-3 col-md-6">
                        <a href="/SoftworksAdminSplash" onClick={(e) => handleCardClick('SoftworksAdminSplash', e)} className="text-decoration-none">
                            <div className="card h-100 shadow-sm border-0 rounded-3 hover-shadow" style={{ backgroundColor: '#ADD8E6' }}>
                                <div className="card-body text-center p-4">
                                    <div className="badge bg-primary bg-opacity-10 text-primary mb-2">REMS</div>
                                    <h4 className="card-title mb-0 fw-bold">Softworks Admin</h4>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .hover-shadow {
                    transition: all 0.3s ease;
                }
                .hover-shadow:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
                }
                .card {
                    transition: all 0.3s ease;
                }
                .badge {
                    font-size: 0.9rem;
                    padding: 0.5rem 1rem;
                }
            `}</style>
        </div>
    );
}

export default Menu;